const linkMapping = {
  agility: 'agility',
  coldRisk: 'cold-risk',
  composure: 'composure',
  conscientiousness: 'conscientiousness',
  hotRisk: 'hot-risk',
  inquisitiveness: 'inquisitiveness',
  interpersonalSkills: 'interpersonal-skills',
  mentalHorsepower: 'mental-horsepower',
  observation: 'observation',
  sociability: 'sociability',
};

const getAttributeLink = (path, id) => (path && id ? `${path}${linkMapping[id]}` : null);

export default getAttributeLink;
